<template>
  <div
    class="fixed w-full h-full top-0 left-0 flex items-center justify-center z-full"
  >
    <div class="bg-black bg-opacity-40 absolute w-full h-full" />
    <div
      class="bg-skin-primary modal-terms z-50 max-w-lg rounded-2xl w-full pt-3 px-3 pb-7 m-4 shadow-request"
    >
      <div class="w-full flex justify-end">
        <div
          v-if="!iconClose"
          @click="$emit('close')"
          class="px-2 cursor-pointer"
        >
          <icon
            :name="'plus'"
            :width="30"
            :height="30"
            :color="'skin-icon-bg-gray'"
            class="transform rotate-45"
          />
        </div>
      </div>

      <h3 class="text-lg font-bold text-center mb-4" v-text="title"></h3>

      <div class="max-h-70 overflow-y-auto light-scroll" v-html="content"></div>
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      default: "",
    },
    iconClose: {
      type: Boolean,
    },
  },
  components: {
    Icon: () => import("../components/Icon.vue"),
  },
};
</script>
<style scoped>
.item-button {
  height: 37px;
  background: #446daf 0% 0% no-repeat padding-box;
  border-radius: 40px;
  align-items: center;
  margin-bottom: 8px;
  color: #fff;
}

.theme-dark .modal-terms {
  background: #163360;
  color: #fff;
}
.theme-dark .item-button {
  background: transparent -webkit-gradient(
      linear,
      right top,
      left top,
      from(#de357a),
      to(#f08f6e)
    ) 0% 0% no-repeat padding-box;
  background: transparent linear-gradient(270deg, #de357a 0%, #f08f6e 100%) 0%
    0% no-repeat padding-box;
}
</style>
